import React, { useCallback } from 'react';
import i18n from '../../../i18n';
import { Languages, DefaultLanguage } from '../../../i18n/languages';

const LanguageButton = ({ location, history, language, token }) => {
  if (!language) {
    language = DefaultLanguage;
  }

  const changeLanguage = useCallback(
    (lng) => {
      history.push(`${location.pathname}?lang=${lng}${token ? `&token=${token}` : ''}`);
      i18n.changeLanguage(lng);
    },
    [history, location, token]
  );

  return (
    <div className='language-switcher'>
      {Object.keys(Languages).map((langKey, index) => {
        return langKey !== language
          ? (
            <button key={index} onClick={() => changeLanguage(langKey)}>
              {Languages[langKey]}
            </button>
          ) : null;
      })}
    </div>
  );
};

export default LanguageButton;
